// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// ***************************************************************** SmsPacks *******************************************************************
const INDEX_SMS_SUCCESS = "INDEX_SMS_SUCCESS";
const SHOW_ONESMS_SUCCESS = "SHOW_ONESMS_SUCCESS";
const STORE_SMS_SUCCESS = "STORE_SMS_SUCCESS";
const DESTROY_SMS_SUCCESS = "DESTROY_SMS_SUCCESS";
const STORE_RULE_PACK_RULE_SUCCESS = "STORE_RULE_PACK_RULE_SUCCESS";

const STORE_SENDTO_SUCCESS = "STORE_SENDTO_SUCCESS";

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// ***************************************************************** SmsPacks *******************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexSuccess(payload) {
  return {
    type: INDEX_SMS_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _SmsSend(payload) {
  return {
    type: STORE_SENDTO_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showSuccess(payload) {
  return {
    type: SHOW_ONESMS_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeSuccess(payload) {
  return {
    type: STORE_SMS_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {Number} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _destroySuccess(payload) {
  return {
    type: DESTROY_SMS_SUCCESS,
    payload: payload,
  };
}

// ******************************************************************** SmsPackRules **********************************************************************

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeSmsPackRuleSuccess(payload) {
  return {
    type: STORE_RULE_PACK_RULE_SUCCESS,
    payload: payload.data,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// ***************************************************************** SmsPacks *******************************************************************
/**
 *
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function index(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get("/SmsPatterns/GetPatterns", { params })
      .then((r) => {
        console.log(r);
        dispatch(_indexSuccess(r));
        callback(false, r);
      })
      .catch((e) => {
        callback(e);
      });
  };
}
/**
 *
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function SmsSendTo(data) {
  return (dispatch) => {
    dispatch(_SmsSend(data));
  };
}
/**
 *
 * @param {Number} smsPack
 * @param {Object} params
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function show(smsPack = {}, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get(`/SmsPatterns/GetPattern`, { params })
      .then((r) => {
        dispatch(_showSuccess(r));
        callback(r);
      })
      .catch((e) => {});
  };
}

/**
 *
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function store(data, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(app.translate("در حال ایجاد پیامک جدید"));

    api
      .post("/SmsPatterns/CreatePattern", { data })
      .then((r) => {
        dispatch(_storeSuccess(r));
        loader.hide(() =>
          app.message(app.translate("پیامک جدید با موفقیت ایجاد شد"))
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.requests.rule-pack",
            "افزودن پیامک با خطا مواجه شد",
            app.translate("افزودن پیامک با خطا مواجه شد")
          )
        );
      });
  };
}

/**
 *
 * @param {Number} smsPack
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function destroy(id, callback = () => {}) {
  console.log("SmsPackSmsPackd", id);
  const params = { id: id };
  return (dispatch, gs, api) => {
    let loader = app.loading(app.translate("در حال حذف پیامک جدید"));

    api
      .delete(`SmsPatterns/RemovePattern`, { params })
      .then((r) => {
        dispatch(_destroySuccess(id));
        loader.hide(() =>
          app.message(app.translate("عملیات حذف با موفقیت انجام شد"))
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.requests.rule-pack",
            "عملیات حذف با موفقیت انجام شد",
            app.translate("عملیات حذف با موفقیت انجام شد")
          )
        );
      });
  };
}
/**
 *
 * @return {Function}
 */
export function emptySmsPacks() {
  return _indexSuccess({ data: { SmsPacks: [] }, meta: {} });
}

// ******************************************************************** SmsPackRules **********************************************************************

/**
 *
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function storeSmsPackRule(data, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(app.translate("در حال انجام عملیات"));

    api
      .post("/SmsPatterns/AddPositionsToPattern", { data })
      .then((r) => {
        dispatch(_storeSmsPackRuleSuccess(r));
        loader.hide(() =>
          app.message(app.translate("عملیات با موفقیت انجام شد"))
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.requests.rule-pack",
            "SmsPack",
            app.translate("عملیات شکست خورد!")
          )
        );
      });
  };
}

/**
 *
 * @param {Number} SmsPackRule
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function destroySmsPackRule(SmsPackRule, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate(
        "routes.home.requests.pattern.rule-pack.Removing SmsPackRule"
      )
    );

    api
      .delete(`SmsPatterns/RemovePatterns`, { SmsPackRule })
      .then((r) => {
        dispatch(_destroySmsPackRuleSuccess(SmsPackRule));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.requests.pattern.rule-pack.SmsPackRule Removed Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.requests.rule-pack",
            "SmsPack",
            app.translate(
              "routes.home.requests.pattern.rule-pack.Removing SmsPackRule Failed"
            )
          )
        );
      });
  };
}
/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptySmsPack() {
  return _showSuccess({ data: { smsPack: {} } });
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(
  state = {
    SmsPacks: [],
    smsPack: {},
    SmsPackRules: [],
    SmsPackRule: {},
    rule: {},
    metaSmsPacks: {},
    metaSmsPackRules: {},
    SendOfId: 0,
  },
  action
) {
  let SmsPacks;
  let smsPack;
  let _index;

  switch (action.type) {
    case STORE_SENDTO_SUCCESS:

    case INDEX_SMS_SUCCESS:
      return Object.assign({}, state, {
        SmsPacks: action.payload?.data?.data,
        metaSmsPacks: action.payload?.data?.meta,
      });
    case SHOW_ONESMS_SUCCESS:
      return Object.assign({}, state, {
        smsPack: action?.payload,
      });

    case STORE_SMS_SUCCESS:
      SmsPacks = app._.cloneDeep(state.SmsPacks);
      SmsPacks?.push(action?.payload);
      return Object.assign({}, state, {
        smsPack: action.payload,
        SmsPacks,
      });
    case DESTROY_SMS_SUCCESS:
      SmsPacks = app._.cloneDeep(state.SmsPacks);
      _index = SmsPacks.findIndex(
        (_SmsPack) => _SmsPack.id === action.payload
      );
      SmsPacks.splice(_index, 1);
      return Object.assign({}, state, {
        SmsPacks,
        smsPack: null,
        SmsPackRule: null,
      });
    case STORE_RULE_PACK_RULE_SUCCESS:
      smsPack = app._.cloneDeep(state.smsPack);
      let _rules = [];
      _rules.push(action.payload);
      if (!app._.isEmpty(smsPack.rules)) {
        _rules.push(...smsPack.rules);
      }
      smsPack.rules = _rules;
      return Object.assign({}, state, {
        SmsPackRule: action.payload,
        smsPack,
      });
    default:
      return state;
  }
}
